import { endpoints } from './endpoints';
import client from '../lib/crypto/client';
import { decrypt } from "../helper/methods";

const isCrypto = process.env.REACT_APP_CRYPTO === "on" ? true : false;
const secureResponse = process.env.REACT_APP_ENABLE_RESPONSE_ENCODING;
console.log('REACT_APP_ENABLE_RESPONSE_ENCODING', process.env.REACT_APP_ENABLE_RESPONSE_ENCODING);

const getFetchBadAssSecure = () => {
    if ("object" === typeof window) {
        let getBadObj = ("object" === typeof window.badAssGuys) ? window.badAssGuys.badAssSecure : ""; // "6693614066929259"
        return getBadObj
    } else {
        return ""
    }
}

const fetchHeader = {
    "Content-Type": "application/json",
    "User-Agent": "WEB/MultipleCampaign",
    "user-agent": "WEB/MultipleCampaign",
    "UserAgent": "WEB/MultipleCampaign",
    "secure-response": !!secureResponse,
} //"appId":data
const fetchHeaderFile = {
    "Content-Type": "application/json",
    "mimeType": "multipart/form-data"
}

const getDecryptedResponse = (res) => {
    console.log('isSecureResponse', res);
    const decryptedResponse = JSON.parse(decrypt(res.data, process.env.REACT_APP_ENC_KEY));
    console.log('decryptedResponse', decryptedResponse);
    return decryptedResponse
}

export default class Api {
    constructor() {
        this.crypto = new client(); //crypto instance
    }

    queryParams = (params) => {
        return Object.keys(params)
            .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
            .join('&');
    }

    fetch = (url, method, body, params, overrideHeader = {}) => {
        let opt = {
            method: method,
            headers: { ...fetchHeader, ...overrideHeader },
            body: body,
            credentials: 'same-origin'
        }

        let getBadAssGuySecure = getFetchBadAssSecure(); // fetch the bad ass secure guy
        console.log("getBadAssGuySecure", getBadAssGuySecure)
        if (getBadAssGuySecure) { // add the encrypted AES key to header
            opt.headers.meta = getBadAssGuySecure;
        }

        if (body && isCrypto) {// add encrypted body if crypto is on
            let encryptedBody = { "body": this.crypto.encryptBody(body) };
            console.log('encryptedBody', encryptedBody);
            opt.body = JSON.stringify(encryptedBody);
        }

        if (params) {
            url += (url.indexOf('?') === -1 ? '?' : '&') + this.queryParams(params);
        }

        let isSecureResponse;
        return fetch(url, opt).then((response) => {
            isSecureResponse = response.headers.get('secure-response');
            return response.json()
        }).then(res => {
            const response = isSecureResponse ? getDecryptedResponse(res) : res;
            if (response.hasOwnProperty('code')) {
                if (response?.data?.code === 401 || response?.code === 401 || response?.status === 401) {
                    // let events = globalVariable?.getPropertyByName("events");
                    // events.publish('httpError', 'failed');
                    return response;
                } else {
                    return response;
                }
            } else {
                return response;
            }
        });
    }

    fetchNormal = (url, method, body, params) => {
        let opt = {
            method: method,
            headers: fetchHeader,
            body: body,
            credentials: 'same-origin'
        }

        // let getBadAssGuySecure = getFetchBadAssSecure(); // fetch the bad ass secure guy
        // console.log("getBadAssGuySecure", getBadAssGuySecure)
        // if (getBadAssGuySecure) { // add the encrypted AES key to header
        //     opt.headers.meta = getBadAssGuySecure;
        // }

        // if (body && isCrypto) {// add encrypted body if crypto is on
        //     let encryptedBody = { "body": this.crypto.encryptBody(body) };
        //     console.log('encryptedBody', encryptedBody);
        //     opt.body = JSON.stringify(encryptedBody);
        // }

        if (params) {
            url += (url.indexOf('?') === -1 ? '?' : '&') + this.queryParams(params);
        }

        let isSecureResponse;
        return fetch(url, opt).then((response) => {
            isSecureResponse = response.headers.get('secure-response');
            return response.json()
        }
        ).then(res => {
            const response = isSecureResponse ? getDecryptedResponse(res) : res;
            return response;
        });
    }

    fetchFile = (url, method, body) => {

        let opt = {
            method: method,
            headers: fetchHeaderFile,
            body: body,
            credentials: 'same-origin'
        }

        return fetch(url, opt).then((response) => response.json())

    }

    buildUrl = (path) => {
        return `${endpoints.baseUrl}${path}`;
    }

}